import React from 'react'

import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { BudgetDonut } from './BudgetDonut'
import { type DetailedBudget } from '../../../core'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface SubBudgetCategoryProps {
  budget: DetailedBudget
}

export const SubBudgetCategory: React.FC<SubBudgetCategoryProps> = ({ budget }) => {
  const {
    amount,
    budgetColors: { background },
    category,
    percentage,
    transaction_total,
  } = budget

  return (
    <>
      <BudgetDonut
        background={background}
        categoryGuid={category.parent_guid}
        percentage={percentage}
      />
      <ListItemText
        primary={
          <Stack component="span" direction="row" justifyContent="space-between">
            <Text bold={true} truncate={true} variant="body1">
              {budget.category.name}
            </Text>
          </Stack>
        }
        secondary={
          <Stack component="span" direction="row" justifyContent="space-between">
            <Text fontWeight={400} variant="body1">
              {`
                ${formatCurrency(transaction_total, '0,0')} / 
                ${formatCurrency(amount, '0,0')}
              `}
            </Text>
          </Stack>
        }
      />
    </>
  )
}
